<template>
  <div class="empty-table-placeholder" :class="{ 'empty-table-placeholder--no-bg': !showBackground }">
    <img v-if="showBackground" :src="img" class="empty-table-placeholder__img" alt="picture"/>
    <div v-if="showBackground" class="empty-table-placeholder__bg"></div>
    <div class="empty-table-placeholder__content" :style="{'height': contentHeight}">
      <img :src="icon" alt="" class="empty-table-placeholder__icon">
      <div class="empty-table-placeholder__texts">
        <p class="h3 color--black-purple">
          {{ title }}
        </p>
        <p class="body-text color--dark-purple">
          {{ description }}
        </p>
      </div>
    <BaseButton
      type="outline"
      v-if="buttonText"
      :skeleton-loading="skeletonLoading"
      @click="$emit('buttonClick')"
    >
      {{ buttonText }}
    </BaseButton>
    </div>
  </div>
</template>

<script>
import BaseButton from '@/views/RenovaDashboard/components/ui-kit/Buttons/BaseButton';

export default {
  name: 'EmptyTablePlaceholder',
  components: {BaseButton},
  emits: ['buttonClick'],
  props: {
    title: {
      type: String,
      default: '',
    },
    description: {
      type: String,
      default: '',
    },
    buttonText: {
      type: String,
      default: '',
    },
    img: {
      type: String,
      default: '',
    },
    icon: {
      type: String,
      default: '',
    },
    contentHeight: {
      type: String,
      default: '432px',
    },
    skeletonLoading: {
      type: Boolean,
      default: false,
    },
    showBackground: {
      type: Boolean,
      default: true,
    },
  },
  computed: {},
};
</script>

<style lang="scss" scoped>
.empty-table-placeholder {
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  width: 100%;
  min-height: 500px;
  position: relative;
  z-index: 0;
  overflow: hidden;

  &--no-bg {
    overflow: visible;
    background: transparent;
  }
}

.empty-table-placeholder__bg {
  position: absolute;
  z-index: 5;
  left: 0;
  top: 0;
  width: 100%;
  height: 100%;
  background-position: bottom;
  background-image: url(/public/img/renova-dashboard/app-preview/app-preview-bg.png);
}

.empty-table-placeholder__img {
  width: 100%;
  max-width: 1640px;
  height: auto;
  position: absolute;
  object-fit: contain;
  object-position: top;
  top: 0;
}

.empty-table-placeholder__content {
  position: absolute;
  z-index: 10;
  left: 50%;
  transform: translateX(-50%);
  width: 700px;
  text-align: center;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  background-image: url(/public/img/renova-dashboard/app-preview/app-preview-container.png);
  background-position: center;
  background-size: 100%;
  top: 88px;
  button{
    width: 160px;
    margin-top: 32px;
    min-height: 40px;
  }
}

.empty-table-placeholder__texts {
  display: flex;
  flex-direction: column;
  gap: 12px;
  width: 347px;
}

.empty-table-placeholder__icon {
  width: 77px;
  height: 77px;
  margin-bottom: 16px;
}
</style>
